import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Input length validation
 * @param length
 * @param trimWhitespace
 * @returns
 */
export function lengthValidator(
  length: number,
  trimWhitespace = false
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control && control.value) {
      const trimmedValueLength = trimWhitespace
        ? control.value.replace(/ /g, '').length
        : control.value.length;

      return trimmedValueLength !== length ? { len: true } : null;
    }

    return null;
  };
}
